import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Compact note page header: back control, title, and projected actions. Deliberately holds no
 * note-specific logic so View and Edit can both use it.
 */
@Component({
  selector: 'app-note-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <header
      class="flex items-center gap-1 border-b border-surface-200 bg-surface-0 px-1 pb-1.5 pt-[max(0.375rem,env(safe-area-inset-top))] dark:border-surface-700 dark:bg-surface-900 sm:gap-2 sm:px-2">
      <button
        type="button"
        class="inline-flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-(--p-text-color) hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary "
        [attr.aria-label]="backLabel()"
        [title]="backLabel()"
        (click)="back.emit()">
        <span class="material-symbols-outlined" aria-hidden="true">arrow_back</span>
      </button>

      <h1
        class="m-0 min-w-0 flex-1 truncate text-base font-semibold sm:text-xl"
        [class]="derived() ? 'italic text-(--p-text-muted-color)' : 'text-(--p-text-color)'"
        [title]="derived() ? 'No title — showing the first line of the note' : title()">
        {{ title() || 'Untitled note' }}
      </h1>

      <div class="flex shrink-0 items-center gap-1">
        <ng-content />
      </div>
    </header>
  `,
})
export class NoteHeaderComponent {
  readonly title = input('');
  /** Title is display-only (derived from content), so render it muted. */
  readonly derived = input(false);
  readonly backLabel = input('Back to notes');
  readonly back = output<void>();
}
